import { createAction, createSlice } from '@reduxjs/toolkit';

export const findCustomers = createAction('user/findCustomers');

const customerSlice = createSlice({
    name: 'customer',
    initialState: {
        view: 'initial',
        searchValue: '',
        activeTab: 'details',
        activeTabType: 'tabs',
        activeComplaintTab: 'details',
        initiateUser: false,
        loading: false,
        error: null,
    },
    reducers: {
        setSearchValue: (state, action) => {
            state.searchValue = action.payload;
        },
        setCustomerView: (state, action) => {
            state.view = action.payload;
        },
        setActiveTabForCustomer: (state, action) => {
            state.activeTab = action.payload;
        },
        setActiveTabForCustomerType: (state, action) => {
            state.activeTabType = action.payload;
        },
        setCustomerComplaintTab: (state, action) => {
            state.activeComplaintTab = action.payload;
        },
        getUser: (state, action) => {
            state.initiateUser = action.payload;
        },
        resetCustomerData: (state) => {
            state.view = 'initial';
            state.activeTab = 'details';
            state.activeTabType = 'tabs';
            state.activeComplaintTab = 'details';
            state.loading = false;
            state.error = null;
        },
        resetInitiateUser: (state) => {
            state.initiateUser = false;
        },
    },
});

export const {
    setSearchValue,
    setCustomerView,
    setActiveTabForCustomer,
    setActiveTabForCustomerType,
    setCustomerComplaintTab,
    getUser,
    resetCustomerData,
    resetInitiateUser,
} = customerSlice.actions;

export default customerSlice.reducer;
